<div class="filter-container">
  <mat-tab-group
    [disablePagination]=true
    (selectedTabChange)="filterClicked($event)"
  >
    <mat-tab *ngFor="let item of filtersType">
      <ng-template mat-tab-label>
        <div *ngIf="item.dirty" class="red-point"></div>
        {{ item.description }}
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
